import { useLanguage } from "@/composables/lang";
import { useLocationSelector } from "@/composables/location";
import { computed, unref, type MaybeRef } from "vue";

export const useDateFormat = (date: MaybeRef<Date>) => {
  const { timezone } = useLocationSelector();
  const { selectedLanguage } = useLanguage();
  const locale = computed(
    () => selectedLanguage.value?.code ?? window.navigator.language
  );

  return computed(() =>
    new Intl.DateTimeFormat(locale.value, {
      weekday: "short",
      month: "short",
      day: "numeric",
      hour12: true,
      hour: "numeric",
      minute: "numeric",
      timeZoneName: "short",
      timeZone: timezone.value,
    }).format(unref(date))
  );
};
